import { BookOpen } from 'lucide-react';

const EmptyState = ({ 
  icon: Icon = BookOpen, 
  title, 
  description, 
  hint,
  actionLabel, 
  onAction 
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="relative w-20 h-20 rounded-full bg-indigo-100 dark:bg-indigo-900/20 flex items-center justify-center mb-6">
        {/* Soft glow effect */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-indigo-400/20 to-purple-400/20 blur-xl dark:from-indigo-500/30 dark:to-purple-500/30" />
        <Icon className="relative w-10 h-10 text-indigo-600 dark:text-indigo-400" />
      </div>
      <h3 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-3">{title}</h3>
      <div className="mb-8">
        <p className="text-gray-600 dark:text-gray-400 text-center max-w-md leading-relaxed">{description}</p>
        {hint && (
          <p className="text-sm text-gray-500 dark:text-gray-500 text-center max-w-lg mt-3">{hint}</p>
        )}
      </div>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-indigo-500 to-purple-500 text-white font-semibold rounded-xl hover:from-indigo-600 hover:to-purple-600 transition-all duration-300 shadow-lg shadow-indigo-500/25 hover:shadow-xl hover:shadow-indigo-500/40 hover:-translate-y-0.5 active:scale-[0.98]"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;

